/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';

/**
 * Getting entire users state into the component
 */
const selectDomain = (state) => state['feature/users'] || initialState;
/**
 * Getting the loader state into the component
 */
export const selectLoader = createSelector([selectDomain], (usersState) => usersState.loading);
/**
 * Getting the users list state into the component
 */
export const selectUsers = createSelector([selectDomain], (usersState) => usersState?.usersList);
/**
 * Getting the roles list state into the component
 */
export const selectRoleList = createSelector([selectDomain], (usersState) => usersState.roleList);
/**
 * Getting the filtered user by user id state into the component
 */
const getFirstParam = (_, param) => param;
export const selectUserById = createSelector(
  [selectUsers, getFirstParam],
  (selectedUsers, userId) => selectedUsers?.results?.filter((user) => user.id === userId)[0]
);
/**
 * Getting the user hotels list state into the component
 */
export const selectUserHotelsList = createSelector(
  [selectDomain],
  (usersState) => usersState.hotelsList?.results
);
/**
 * Getting the updated user state into the component
 */
export const selectUpdatedUser = createSelector(
  [selectDomain],
  (usersState) => usersState.updatedUser
);
/**
 * Getting the  hotels selection list for dropdown  state into the component
 */
export const selectHotelsSelectionList = createSelector([selectDomain], (usersState) =>
  usersState.hotelSelectionList?.results?.map((data) => ({
    label: data?.name,
    id: data?.id,
    pmsDate: data?.pmsStartDate,
  }))
);
/**
 * Getting the logged user hotels list state into the component
 */
export const selectLoggedUserHotelsList = createSelector([selectDomain], (usersState) =>
  usersState.loggedUserHotelsList?.results
    ?.map((data) => ({
      label: data?.hotel?.name,
      id: data?.hotel?.id,
      pmsDate: data?.hotel?.pmsStartDate,
    }))
    .sort((a, b) => a?.label?.localeCompare(b.label))
);
/**
 *  Getting  hotel groups state to the component
 */
export const selectHotelGroups = createSelector([selectDomain], (state) => state.hotelGroups);
/**
 *  Getting assigned hotel groups state to the component
 */
export const selectAssignedHotelGroups = createSelector(
  [selectDomain],
  (state) => state.assignedHotelGroups
);
